import { runtimeConfig } from "@src/runtime-config";
import { SettingsApiTypes } from "@stellar/settings-api-client";
import { RuntimeUtils } from "@stellar/utils";

interface TransmitSettingsToParentParams {
  /** The setting identifier */
  settingIdentifier: SettingsApiTypes.SettingsIdentifierByScope<"USER">;
  /** The setting value */
  settingValue: SettingsApiTypes.SettingsValueByScope["USER"][SettingsApiTypes.SettingsIdentifierByScope<"USER">];
}

/** Transmit the updated setting to the parent window */
export function transmitSettingsToParent({
  settingIdentifier,
  settingValue,
}: TransmitSettingsToParentParams): void {
  const message: SettingsApiTypes.SettingPageMessage = {
    action: "updateSetting",
    data: { settingIdentifier, settingValue },
  };

  // Need to allow specific origins in for security reasons
  const targetOrigins = RuntimeUtils.isProductionEnvironment(
    runtimeConfig.appEnv
  )
    ? runtimeConfig.urls.sphereViewerUrl
    : "*";

  window.parent.postMessage(message, targetOrigins);
}
